import { CartItemData } from '.';

export enum ItemType {
  Singular = 'singular',
  Countable = 'countable',
  Loose = 'loose',
}

export type GetItemTypeItem = Pick<CartItemData, 'loose' | 'quantity' | 'unit'>;

export const getItemType = (article: GetItemTypeItem): ItemType => {
  const { quantity, unit, loose } = article;
  if (quantity && unit && loose) {
    return ItemType.Loose;
  }
  if (quantity && unit && !loose) {
    return ItemType.Countable;
  }
  return ItemType.Singular;
};
